<template>
  <div class="answer-deit">
    <div class="title">问答设置</div>
      <van-form 
        class="com-box" 
        input-align="right" 
        :show-error-message="false" 
        validate-first
        validate-trigger="onSubmit" 
        ref="form"
      >
        <van-field
          class="van-field"
          v-model="form.backgroundMusicName"
          label="背景音乐"
          readonly
          placeholder="请选择"
          @click="isMusic = true"
        >
          <van-icon name="arrow" slot="right-icon"/>
        </van-field>
        <van-field
          required
          class="van-field"
          v-model="createType"
          label="创建类型"
          readonly
          placeholder="请选择"
          :rules="[{required: true, message: '请选择创建类型' }]"
          @click="changeActionSheet(1)"
        >
          <van-icon name="arrow" slot="right-icon"/>
        </van-field>
        
        <template v-if="form.questionType == 'definition'">
          <div class="add-range-btn" @click="isCreateQuestion = true">
            <van-icon name="plus"  v-if="questionNum == 0" />
            创建题库
            <span v-if="questionNum > 0">({{questionNum}}道题)</span>
          </div>
          <div class="com-box">
            <div class="title">
              首页背景图
              <span class="title-tip">（建议尺寸750像素 X 1334像素）</span>
            </div>
            <van-uploader 
              class="uploader" 
              :fileList="homeBackground" 
              :max-count="1" 
              preview-size="97" 
              result-type="file"
              :before-read="beforeImgUpload" 
              :after-read=" (e) => uploadImg(e,'homeBackground')"
              @delete="(file) => deleteImg(file,'homeBackground')"
            />
          </div>
          <div class="com-box bottom">
            <div class="title">
              题目背景图
              <span class="title-tip">（建议尺寸750像素 X 1334像素）</span>
            </div>
            <van-uploader 
              class="uploader" 
              :fileList="questionBackground" 
              :max-count="1" 
              preview-size="97" 
              result-type="file"
              :before-read="beforeImgUpload" 
              :after-read=" (e) => uploadImg(e,'questionBackground')"
              @delete="(file) => deleteImg(file,'questionBackground')"
            />
          </div>
        </template>
        <van-field
          required
          v-if="form.questionType && form.questionType != 'definition'"
          class="van-field"
          v-model="subject"
          label="试卷选择"
          readonly
          placeholder="请选择"
          :rules="[{ required: true, message: '请选择试卷' }]"
          @click="isSubject = true"
        >
          <van-icon name="arrow" slot="right-icon"/>
        </van-field>
        <van-field
          required
          class="van-field"
          v-model="answer"
          label="答题类型"
          readonly
          placeholder="请选择"
          :rules="[{ required: true, message: '请选择答题类型' }]"
          @click="changeActionSheet(2)"
        >
          <van-icon name="arrow" slot="right-icon"/>
        </van-field>
        <van-field
          required
          v-model="form.questionNumber"
          label="题目数量"
          label-width="18em"
          input-align="left"
          placeholder="请输入"
          type="digit"
          :rules="[{ required: true, message: '请输入题目数' }]"
          @blur="checkFeeValid('questionNumber')"
        />
        <van-field
          required
          v-model="form.scorePerQuestion"
          label="答题分数(每道题)"
          label-width="18em"
          input-align="left"
          placeholder="请输入"
          type="digit"
          maxlength="3"
          :rules="[{ required: true, message: '请输入答题分数' }]"
          @blur="checkFeeValid('scorePerQuestion')"
        />
        <van-field
          required
          class="van-field"
          v-model="time"
          label="答题时间"
          readonly
          placeholder="请选择"
          :rules="[{ required: true, message: '请选择答题时间' }]"
          @click="changeActionSheet(3)"
        >
          <van-icon name="arrow" slot="right-icon"/>
        </van-field>
        <van-field
          required
          v-if="form.answerTime && form.answerTime !='no'"
          v-model="form.limitTime"
          label="限制时间(秒)"
          label-width="18em"
          input-align="left"
          placeholder="请输入"
          type="digit"
          maxlength="2"
          @blur="checkFeeValid('limitTime')"
          :rules="[{ required: true, message: '请输入限制时间' }]"
        />
        <van-field
          required
          :disabled="!form.scorePerQuestion"
          v-model="form.lotteryScoreLimit"
          label="挑战成功分数"
          placeholder="请输入"
          label-width="18em"
          input-align="left"
          type="digit"
          :rules="[{ required: true, message: '请输入门槛分数' }]"
          @blur="checkFeeValid('lotteryScoreLimit')"
        />
        <div class="tips">达到分数，即挑战成功（设置抽奖组件即可抽奖）</div>
        <template v-if="isHaslottery">
          <div class="title">抽奖限制</div>
          <van-field
            required
            class="van-field"
            v-model="lottery"
            label="抽奖机会赠送"
            readonly
            placeholder="请选择"
            :rules="[{ required: true, message: '请选择抽奖机会赠送' }]"
            @click="changeActionSheet(4)"
          >
            <van-icon name="arrow" slot="right-icon"/>
          </van-field>
        
          <van-field
            required
            v-model="form.sendLotteryTimes"
            label-width="12em"
            input-align="left"
            label="每人赠送"
            placeholder="请输入"
            type="digit"
            maxlength="3"
            :rules="[{ required: true, message: '请输入赠送抽奖机次数' }]"
            @blur="checkFeeValid('sendLotteryTimes')"
          >
          <span slot="right-icon">次抽奖机会</span>
        </van-field>
        </template>
        <van-field
          required
          v-model="everyDaySendName"
          label="答题机会赠送"
          input-align="right"
          placeholder="请选择"
          is-link
          readonly
          :rules="[{ required: true, message: '请选择答题机会赠送' }]"
          @click="changeActionSheet(5)"
        />
        <van-field
          required
          v-model="form.sendAnswerTimes"
          type="digit"
          :maxlength="4"
          :label="label"
          label-width="13em"
          input-align="left"
          placeholder="请输入"
          :rules="[{ required: true, message: '请输入答题次数' }]"
          @blur="checkFeeValid('sendAnswerTimes')"
        >
          <span slot="right-icon">答题次数</span>
        </van-field>
        <!-- <van-field
          v-if="isHasSignUp"
          v-model="form.signUpSendCount"
          type="digit"
          :maxlength="4"
          label="顾客成功报名活动,可获得"
          label-width="12em"
          input-align="center"
          placeholder="请输入"
          @blur="checkFeeValid('signUpSendCount')"
        >
          <span slot="right-icon">次问答机会</span>
        </van-field> -->
     </van-form>
     <create-question-pop
      :activityId="activityId"
      :isClone="isClone"
      :questionType="form.questionType"
      @questionSuccess="questionSuccess" 
      :isCreateQuestion.sync="isCreateQuestion" 
      v-if="isCreateQuestion"
    />
     <van-action-sheet v-model="isActionSheet" cancel-text="取消" :actions="actions" get-container="body"  @select="onSelect" />
     <van-popup v-model="isSubject" position="bottom" get-container="body">
      <van-picker
        show-toolbar
        :columns="questionBank"
        @confirm="selectSubject"
        @cancel="isSubject = false"
      />
     </van-popup>
    <van-popup v-model="isMusic" position="bottom" get-container="body">
      <van-picker
        value-key="name"
        show-toolbar
        :columns="musicList"
        @confirm="musicConfirm"
        @cancel="onCancelMusic"
      />
    </van-popup>
  </div>
</template>

<script>
const homeBackImg = 'https://img3.quanyou.com.cn/joy/group1/M00/14/CB/rB4ChWL0ufCARwhpAA1b5TenLOc864.png'
const questionImg = 'https://img3.quanyou.com.cn/joy/group1/M00/14/D4/rB4ChWL1sLKACl2OABQSmSUdhLw379.png'
import { round2Places } from '@/utils/utils'
import createQuestionPop from './create-question-pop.vue'
export default {
  name: "questionEdit",
  components: {
    createQuestionPop
  },
  props: {
    value: {
      type: Object,
      default() {
        return {}
      }
    },
    isHasSignUp: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      musicList: [],
      isMusic: false,
      homeBackground: [{url: homeBackImg}],
      questionBackground: [{url: questionImg}],
      isCreateQuestion: false,
      form: {
        backgroundMusic: '',
        backgroundMusicName: '',
        questionType: '',
        homeBackground: questionImg,
        questionBackground: questionImg,
        templateId: '',
        answerType: '',
        questionNumber: '',
        scorePerQuestion: '',
        answerTime: '',
        limitTime: '',
        lotteryChanceType: '',
        lotteryScoreLimit: '',
        sendLotteryTimes: '',
        answerChanceSendType: '',
        sendAnswerTimes: '',
        signUpSendCount: ''
      },
      choiceType: 1,
      createType: '',
      isActionSheet: false,
      actions: [{name: '题库',type: 'template'},{name: '自定义', type: 'definition'}],

      subject: '',
      isSubject: false,
      questionBank: [],
      answer: '',
      time: '',
      lottery:'',
      questionNum: 0,
      bankNumber: 0, // 题库数量
      totalNumber: 0, // 自定义题目数量,
      everyDaySendName: '',
      questionTotals: 0,
      activityId: this.$route.query.activityId || '',
      isClone: this.$route.query.from == 'clone'
    }
  },
  computed: {
    // activityId() {
    //   return  this.$route.query.activityId || ''
    // },
    // isClone() {
    //   return this.$route.query.from == 'clone';
    // },
    from() {
      return this.$route.query.from
    },
    isHaslottery() {
      return JSON.parse(this.value.isHaslottery)
    },
    label() {
      return this.form.answerChanceSendType == 'everyDay' ? '每人每日赠送' : '本场活动赠送'
    },
    // 组件创建方式
    creationMode() {
      return this.$route.query.creationMode != 'new' ? true : false
    },
  },
  // watch: {
  //   $route: {
  //     handler() {
  //       this.queryQuestionTotalNumber()
  //     }
  //   }
  // },
  methods: {
    changeActionSheet(type) {
      // 编辑时 不能改变创建类型
      if (this.from == 'manager' && type == 1) return
      // 1: 创建类型 2：答题类型 3：问答时间 4： 抽奖机会赠送
      this.choiceType = type
      if (type == 1) {
        this.actions = [{name: '题库',type: 'template'},{name: '自定义', type: 'definition'}]
      }else if (type == 2) {
        this.actions = [{name: '随机抽题',type: 'random'},{name: '固定顺序',type: 'sequence'}] 
      }else if (type == 3) {
        this.actions = [{name: '不限',type: 'no'},{name: '总时间限制',type: 'totalLimit'},{name: '每道题限制',type: 'everyLimit'}]
      }else if (type == 4) {
        // this.actions = [{name: '一次性赠送',type: 'first'},{name: '完成赠送',type: 'everyTime'}]
        this.actions = [{name: '挑战成功只送一次',type: 'first'},{name: '每次挑战成功都送',type: 'everyTime'}]
      }else if (type == 5) {
        this.actions = [ {name: '每日赠送',type: 'everyDay'},{name: '一次性赠送',type: 'first'}]
      }
      this.isActionSheet =true
    },
    onSelect(e) {
      const { name, type} = e
      this.isActionSheet = false
      if (this.choiceType == 1) {
        // 清空题目数和抽奖门槛分数
        this.form.questionNumber = null
        this.form.lotteryScoreLimit = null
        this.form.questionType = type
        this.createType = name
        this.queryQuestionTotalNumber()
        if (name == '题库') {
          this.questionNum = this.bankNumber
        }else {
          this.questionNum = this.totalNumber
        }
      }else if (this.choiceType == 2) {
        this.form.answerType = type
        this.answer = name
      }else if (this.choiceType == 3) {
        this.form.answerTime = type
        this.time = name
      }else if (this.choiceType == 4) {
        this.form.lotteryChanceType= type
        this.lottery= name
      } else if (this.choiceType == 5) {
        this.form.answerChanceSendType = type
        this.everyDaySendName = name
      }
    },
    // 选择题库
    selectSubject(e) {
      const { text, questionGroupId,questionNum} = e
      this.form.questionNumber = ''
      this.form.templateId = questionGroupId
      this.subject = text
      this.questionNum = questionNum
      this.bankNumber = questionNum
      this.isSubject = false
    },
    checkFeeValid(fieldName) {
      let value = this.form[fieldName]
      // 题目数 不能最小为1，不能大于试卷选择题数
      if (fieldName == 'questionNumber') {
        if (value == 0) {
          value = 1 
        }else if (value > this.questionNum) {
           value = this.questionNum
        }
      }
      // 答题分数
      if (fieldName == 'scorePerQuestion') {
        this.form.lotteryScoreLimit = null
        if (value == 0) value = 1
      }
      if (fieldName == 'scorePerQuestion') {
        if (value < 0) value = 1
        if (value > 100) value = 100
      }
      if (fieldName == 'limitTime') {
        if (value > 60) value  = 60
      }
      if (fieldName == 'lotteryScoreLimit') {
        if (Number(value) < this.form.scorePerQuestion) {
          value = this.form.scorePerQuestion
        } else if (value > this.questionNum * this.form.scorePerQuestion) {
          value =  this.questionNum * this.form.scorePerQuestion
        }
      }
      this.form[fieldName] = round2Places(value)
    },
    // 试卷创建成功 获取题目数
    questionSuccess() {
      this.queryQuestionTotalNumber()
    },
    beforeImgUpload(file) {
      const acceptTypes = ['image/png', 'image/jpeg', 'image/gif'];
      if (!acceptTypes.includes(file.type)) {
        this.$toast('请上传png、jpg或gif格式图片');
        return false;
      }
      return true;
    },
    uploadImg(file,type) {
      const currentFile = {
        url: '',
        status:'uploading',
        message: '上传中...'
      }
      this[type].push(currentFile)
      this.$api.common.uploadImg(file.file)
        .then(({data}) => {
          if (data && data[0]) {
            const fileUrl = data[0].fileUrl;
            this.form[type] = fileUrl
            this[type][0].url = fileUrl
            this[type][0].status = 'done'
            delete this[type][0].status
            delete this[type][0].message
          }
        })
        .catch(err => {
          const currentIndex = this[type].indexOf(currentFile);
          if (currentIndex > -1) {
            this[type].splice(currentIndex, 1);
            this.form[type] = ''
          }
      });
    },
    deleteImg(file,type) {
      this[type] = []
      this.form[type] = ''
    },
    onFailed(activityId) {
      return new Promise((resolve,reject) => {
        if (this.createType=='自定义' && this.totalNumber <= 0) {
          this.$toast('请先创建题库')
          return 
        }
        this.$refs.form.validate().then(res => {
          this.form.questionTotals = this.createType == '自定义' ? this.totalNumber : this.bankNumber
          if (activityId) {
            this.form.activityId = activityId
          }else {
            this.form.activityId = this.isClone ? '' : this.activityId 
          }
          this.$api.question.saveQuestionBaseDetail(this.form).then(res => {
            if (res.success) {
             resolve(true)
            }
          })
        }).catch(err => {
          this.$toast(err[0].message);
          reject(false)
        })
      })
     
    },
    // 获取音乐列表
    getBackgroundMusicList() {
      this.$api.question.getBackgroundMusicList().then(res => {
        if (res.success && res.data) {
          this.musicList = res.data
        }
      })
    },
    // 选择音乐
    musicConfirm(e) {
      const { name, url} = e
      this.form.backgroundMusicName = name
      this.form.backgroundMusic = url
      this.isMusic = false
    },
    onCancelMusic() {
      this.isMusic = false
    },
    queryQuestionDetail() {
      let activityId = this.isClone ? "" : this.activityId 
      this.$api.question.queryQuestionDetail({activityId}).then(res => {
        if (res.success && res.data) {
          this.form = res.data
          const {homeBackground, questionBackground} = this.form
          if (homeBackground) {
            this.homeBackground[0].url = homeBackImg
          }
          if (questionBackground) {
            this.questionBackground[0].url = questionBackground
          }
          this.queryQuestionTotalNumber()
          this.initChange()
        }
      })
    },
    queryQuestionTotalNumber() {
      let activityId = this.isClone ? '' : this.activityId 
      this.$api.question.queryQuestionTotalNumber({
        activityId,
        questionType: this.form.questionType
      }).then(res => {
        this.questionNum =  res.data
        this.totalNumber = res.data
      })
    },
    initChange() {
      if (this.form.questionType) {
        this.createType = this.form.questionType == 'template' ? '题库' : '自定义'
      }
      if (this.createType === '自定义') {
        this.homeBackground = [{url: this.form.homeBackground}]
        this.questionBackground = [{url: this.form.questionBackground}]
      }
      if(this.form.questionType == 'template') {
        this.questionBank.forEach(item => {
          if (item.questionGroupId == this.form.templateId) {
            this.subject = item.text
            this.questionNum = item.questionNum
            this.bankNumber = item.questionNum
          }
        }) 
      }
      if (this.form.answerType) {
        this.answer = this.form.answerType == 'random' ? '随机抽题' : '固定顺序'
      }
      if (this.form.answerTime) {
        this.time = this.form.answerTime == 'no' ? '不限制' : this.form.answerTime == 'totalLimit' ? '总时间限制' : '每道题限制'
      }
      if (this.form.lotteryChanceType) {
        this.lottery = this.form.lotteryChanceType == 'first' ? '挑战成功只送一次' : '每次挑战成功都送'
      }
      if (this.form.answerChanceSendType) {
        this.everyDaySendName = this.form.answerChanceSendType == 'everyDay' ? '每日赠送' : '一次性赠送'
      }
    },
    // 获取题库
    queryBaseQuestionGroupList() {
      let params = {
        pageNum: 1,
        pageSize: 1000
      }
      this.$api.question.queryBaseQuestionGroupList(params).then(res => {
        if (res.success && res.data.list) {
          res.data.list.forEach(item => {
            item.text = `${item.groupName}（${item.questionNum}）`
          });
          this.questionBank = res.data.list
          this.queryQuestionDetail()
        }
      })
    },
    createAnswer() {
      this.$router.push({path: '/question-create', query: this.$route.query})
    },
    init(activityId) {
      if (activityId) {
        this.isClone = false
        this.activityId = activityId
      }
      this.getBackgroundMusicList()
      this.queryQuestionTotalNumber()
      this.queryBaseQuestionGroupList()
    }
  },
  mounted() {
   if (this.isClone) {
    this.$api.question.questionClone(this.activityId).then(res => {
      this.getBackgroundMusicList()
      this.queryQuestionTotalNumber()
      this.queryBaseQuestionGroupList()
    })
   }else {
    this.init()
   }
  
  }
}
</script>

<style lang="stylus" scoped>
  .answer-deit {
    margin: 0px 15px 15px 15px;
    height: 100%;
    .title {
      font-size: 14px;
      font-weight: bold;
      color: #303133;
      padding-top: 20px;
    }
    .com-box {
      height: 100%;
      .add-range-btn {
        margin 10px
        padding 10px 0
        text-align: center
        color $mainTextColor
        font-size 14px
        font-weight 600
        border 1px solid $mainTextColor
        border-radius 8px
      }
      .title {
        background: #f4f4f4;
        .title-tip {
          margin-left 10px
          font-size 12px
          color #999
        }
      }
      .tips {
        background: #fff;
        padding: 10px 16px;
        font-size: 10px;
        color: #bbb;
      }
      .com-box {
        padding: 10px;
        background-color: #fff
        .title {
          font-size: 14px;
          font-weight: bold;
          color: #303133;
          background-color: #fff
          margin-bottom: 10px;
        }
        .number {
          display: flex;
          justify-content: space-between;
          padding: 10px 16px;
          span {
            color: #606266;
            font-weight: 600;
          }
          .del {
            color: #ff6b31;
            font-weight: none;
          }
        }
      }
    }
  }
</style>